'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index_es = require('../../node_modules/slate/dist/index.es.js');
var types = require('../types.js');

/**
 * Adds backspace command to editor
 */

var withDeleteBackwards = editor => {
  var {
    deleteBackward
  } = editor;

  editor.deleteBackward = function () {
    var {
      selection
    } = editor;

    if (selection && index_es.Range.isCollapsed(selection)) {
      var match = index_es.Editor.above(editor, {
        match: n => index_es.Editor.isBlock(editor, n)
      });

      if (match) {
        var [block, path] = match;
        var start = index_es.Editor.start(editor, path);

        if (block.type !== 'paragraph' && index_es.Point.equals(selection.anchor, start)) {
          index_es.Transforms.setNodes(editor, {
            type: 'paragraph'
          });

          if (block.type === 'list-item') {
            index_es.Transforms.unwrapNodes(editor, {
              match: n => types.LIST_TYPES.includes(!index_es.Editor.isEditor(n) && index_es.Element.isElement(n) && n.type),
              split: true
            });
          }

          return;
        }
      }

      deleteBackward(...arguments);
    }
  };

  return editor;
};

exports.withDeleteBackwards = withDeleteBackwards;
